import 'react';
import { Box, Typography } from '@mui/material';

/** Inline SVG — avoids /img/*.svg network fetch (broken when static img volume is incomplete). */
function UpMark() {
    return (
        <svg
            viewBox="0 0 1024 1024"
            width={18}
            height={18}
            aria-hidden
            focusable="false"
            style={{ display: 'block' }}
        >
            <path
                d="M508.3 60.4c-2.9 0-6 3.2-8.9 3.2L283.3 358.7c-2.9 3.2-2.9 6.3-2.9 6.3 0 3.2 0 6.3 2.9 6.3 2.9 3.2 8.9 6.3 11.9 3.2L364 343l141-187.3c2.9-3.2 6-3.2 8.9 0l147.4 203.1 56.9 15.7c6 3.2 8.9 0 11.9-3.2 2.9-3.2 2.9-9.4 0-15.7L514.3 60.4c2.9 3.2 0 0-6 0z m0 161.8c-2.9 0-6 3.2-8.9 3.2L283.3 521c-2.9 3.2-2.9 6.3-2.9 6.3 0 3.2 0 6.3 2.9 6.3 2.9 3.2 8.9 6.3 11.9 3.2l144-60.2c6 231.9-24.3 339.8-237 479.5 183.1-38.2 351.2-114.1 375-479.5l144 60.1c6 3.2 8.9 0 11.9-3.2 2.9-3.2 2.9-9.4 0-15.7L517.4 222h-9l-0.1 0.2z"
                fill="#4ECB73"
            />
        </svg>
    );
}

function DownMark() {
    return (
        <svg
            viewBox="0 0 1024 1024"
            width={18}
            height={18}
            aria-hidden
            focusable="false"
            style={{ display: 'block' }}
        >
            <path
                d="M524.8 963.3c-2.9 0-5.7-3.1-8.6-3.1L307.8 663.8c-2.9-3.1-2.9-6.3-2.9-6.3 0-3.1 0-6.3 2.9-6.3 2.9-3.1 8.6-6.3 11.4-3.1l66.3 31.5 135.8 188.1c2.9 3.1 5.7 3.1 8.6 0l142-203.9 54.9-15.8c5.7-3.1 8.6 0 11.4 3.1s2.9 9.4 0 15.8L530.5 963.3c2.8-3.1 0 0-5.7 0z m0-162.4c-2.9 0-5.7-3.1-8.6-3.1L307.8 500.9c-2.9-3.1-2.9-6.3-2.9-6.3 0-3.1 0-6.3 2.9-6.3 2.9-3.1 8.6-6.3 11.4-3.1L458 545.6c5.7-232.8-23.3-341.1-228.3-481.4 176.4 38.4 338.5 114.6 361.5 481.4l138.7-60.5c5.7-3.1 8.6 0 11.4 3.1 2.9 3.1 2.9 9.4 0 15.8l-208 296.9h-8.5z"
                fill="#d81e06"
            />
        </svg>
    );
}

export function UpDownIconDisplay({ changePercent }: { changePercent: number }) {
    const isPositive = changePercent > 0;
    const isNegative = changePercent < 0;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
            {isNegative && (
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', height: '18px' }}>
                    <DownMark />
                </Box>
            )}
            {isPositive && (
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', height: '18px' }}>
                    <UpMark />
                </Box>
            )}
            <Typography
                variant="body2"
                sx={{
                    fontSize: 14,
                    color: isPositive ? 'success.main' : isNegative ? 'error.main' : 'text.primary',
                }}
            >
                {changePercent.toFixed(2)}%
            </Typography>
        </Box>
    );
}
